<div class="company-suggestion" data-qa="company-preselection">
  <div class="row" data-qa="preselection-title-row">
    <div class="col-12" data-qa="preselection-title-col">
      <span class="registration-title">We think we've found a match.</span>
    </div>
  </div>
  <div class="row registration-sub-title" data-qa="preselection-subtitle-row">
    <div class="col-12" data-qa="preselection-subtitle-col">
      <span
        >Your company may already have a profile. Select an existing profile
        from the list below to request to join an existing account or claim a
        profile.</span
      >
    </div>
  </div>
  <div class="cards selected" data-qa="preselected-vendor">
    <suggestion-vendor-card
      [vendor]="vendor"
      [isClaimed]="!!vendor.isRegistered"
      (toggleCardSelection)="onToggleCardSelection($event)"
    ></suggestion-vendor-card>
  </div>
  <div class="registration-section-footer margin-top-32" data-qa="preselection-footer">
    <div class="col-left" data-qa="preselection-cancel">
      <s-button
        type="tertiary"
        label="My company is not here"
        (click)="onCancelClick()"
      ></s-button>
    </div>
    <div class="col-right" data-qa="preselection-confirm">
      <s-button
        type="primary"
        label="Join company"
        (click)="onSelectClick()"
      ></s-button>
    </div>
  </div>
</div>
